var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg7M(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88 166.222C131.201 166.222 166.222 131.201 166.222 88C166.222 44.7991 131.201 9.77778 88 9.77778C44.7991 9.77778 9.77778 44.7991 9.77778 88C9.77778 131.201 44.7991 166.222 88 166.222ZM88 176C136.601 176 176 136.601 176 88C176 39.3989 136.601 0 88 0C39.3989 0 0 39.3989 0 88C0 136.601 39.3989 176 88 176Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M96.2104 138.453V98.5601H101.791L116.365 132.906H113.711L128.177 98.5601H133.757V138.453H127.526L127.472 108.926L129.314 109.374L117.286 138.453H112.681L100.382 109.374L102.333 108.926L102.387 138.453H96.2104Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3444 91.52C58.1454 91.52 56.4845 90.9526 55.3616 89.818C54.2387 88.6833 53.6772 87.1468 53.6772 85.2085C53.6772 84.0265 53.8878 82.821 54.3089 81.5918C54.7767 80.3626 55.5019 78.8733 56.4845 77.1241C57.467 75.3275 58.7303 73.0819 60.2742 70.3871L72.2049 49.7506H49.1857C48.4839 49.7506 47.9224 49.9397 47.5013 50.3179C47.127 50.6489 46.7528 51.3817 46.3785 52.5163C46.0042 53.6037 45.4427 55.2584 44.6941 57.4804H42.2378L46.8697 39.8933H79.7845V43.4391L69.6784 61.0262C68.0877 63.7683 66.9414 66.1794 66.2396 68.2596C65.5846 70.2925 65.2571 72.1363 65.2571 73.791C65.2571 75.0675 65.374 76.2495 65.608 77.3368C65.8419 78.3769 66.0992 79.3697 66.38 80.3153C66.6607 81.2136 66.918 82.1118 67.1519 83.0101C67.3859 83.8611 67.5028 84.7121 67.5028 85.5631C67.5028 87.596 66.801 89.1088 65.3974 90.1017C63.9938 91.0472 62.3095 91.52 60.3444 91.52Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.2457 119.778L114.986 57.0372L121.324 63.375L58.5835 126.116L52.2457 119.778Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg7M);
export default __webpack_public_path__ + "static/media/7m.628e5ea9e7bb8860a0fa9da02559671d.svg";
export { ForwardRef as ReactComponent };